import React from 'react';
import { useNavigate } from 'react-router-dom';
import backgroundVideo from '../../assets/Video/42922-434300957.mp4'; // Replace with your video path

const Quote = () => {
  const navigate = useNavigate();

  return (
    <div className="relative w-full h-[600px] overflow-hidden">
      {/* Background Video */}
      <video
        className="absolute top-0 left-0 w-full h-full object-cover"
        src={backgroundVideo}
        autoPlay
        loop
        muted
        playsInline
        loading="lazy"
      />

      {/* Overlay Content */}
      <div className="absolute inset-0 bg-black/50 flex flex-col items-center justify-center text-center text-white px-4">
  <h2 className="text-4xl font-bold mb-4" style={{color:'#e6b127'}}>Engineering Tomorrow’s Success</h2>
  <p className="text-lg max-w-2xl mb-6">
    We specialize in transforming your vision into reality through innovative EPC solutions. Let’s partner up and shape the future, one project at a time.
  </p>
  <button
    onClick={() => navigate('/contact')}
    className="bg-[#5bc0fe] hover:bg-[#3aa7e0] text-white font-semibold px-6 py-3 rounded-xl transition duration-300"
  >
    Schedule a Consultation
  </button>
</div>
    </div>
  );
};

export default Quote;
